export const SET_TEDY = 'SET_TEDY';
export const SET_REACTIONS = 'SET_REACTIONS';
export const SET_FOLLOW = 'SET_FOLLOW';
export const SET_RANDOM = 'SET_RANDOM';
export const SET_RANDOMFRIENDS = 'SET_RANDOMFRIENDS';
export const SET_RANDOMPOSTS = 'SET_RANDOMPOSTS';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';

export default {
  [SET_TEDY]: (state, products) => (state.tedy = products),
  [SET_REACTIONS]: (state, products) => (state.reactions = products),
  [SET_FOLLOW]: (state, products) => (state.follow = products),
  [SET_RANDOM]: (state, products) => (state.random = products),
  [SET_RANDOMFRIENDS]: (state, products) => (state.randomFriends = products),
  [SET_RANDOMPOSTS]: (state, products) => (state.posts = products),
  [SET_NOTIFICATIONS]: (state, products) => (state.notifications = products),
  /* Product creation */
  setProductCreationPending: (state, value) => (state.productCreationPending = value),
};
